import { createReducer, on, Action } from '@ngrx/store';
import { retrieveEnv, retrieveWebSiteConfig } from  './usb-configuration-actions';
import { WebSiteConfig } from './ubs-config-model';

export const initialState: Readonly<WebSiteConfig> = {};

export const initialEnvState: Readonly<any> = {};

export const configurationReducer = createReducer(
    initialState,
    on(retrieveWebSiteConfig, (state, { webSiteConfig }) => webSiteConfig)
  );

export const environReducer = createReducer(
  initialEnvState,
  on(retrieveEnv,(state,{env}) => env)
)
